import axios from 'axios';
import { API_CONFIG, STORAGE_KEYS } from '../../constants';
import {
  Event,
  SendEventPayload,
  SendEventResponse,
} from '../../types/events.types';

const SERVER_URL = API_CONFIG.SERVER_URL;

const api = axios.create({
  baseURL: SERVER_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
      localStorage.removeItem(STORAGE_KEYS.USER);
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export const getEvents = async (params?: {
  workspaceId?: string;
}): Promise<Event[]> => {
  try {
    const response = await api.get('events/', { params });
    const data = response.data?.data ?? response.data;
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};

export const sendEvent = async (
  payload: SendEventPayload
): Promise<SendEventResponse> => {
  try {
    const response = await api.post<SendEventResponse>('events/', payload);
    return response.data;
  } catch (error) {
    console.error('Error sending event:', error);
    throw error;
  }
};
